export default "__VITE_ASSET__uRa1Z7xq__"